import { atom } from 'recoil';
import { TaskView } from '~/backend/connector-next-api/connector-next-schemas';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';

type AutoSegmentationTaskState = {
    model?: GenerationModelDetails;
    customizationName?: string;
    subSelectedStructures?: string[];
    output?: TaskView;
    polling?: boolean;
    includeStructureSet?: boolean;
};

export const autoSegmentationTaskState = atom<AutoSegmentationTaskState>({
    key: 'autoSegmentationTaskState',
    default: undefined,
});
